//highchart
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

//react
import { useEffect, useState } from 'react';

//service
import { getWeekEvtList } from '../../../service/monitor/monitorDashboardService';

//component
import { BeatLoader } from 'react-spinners';
import { numFormat } from '../../../com/dataUtil';

const WeekEventChart = ({ conn, dongCode }) => {
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({
    warn: [],
    danger: [],
    off: [],
  });
  const initChartDataFunc = () => {
    setLoading(true);
    /* 서비스 조회 */
    getWeekEvtList(conn, dongCode).then(response => {
      /* 주간 이벤트 발생 객체데이터 생성 */
      let result = {
        warn: [],
        danger: [],
        off: [],
      };
      response.forEach(item => {
        result.warn.push({ name: item.gathDtm, y: item.warnCnt });
        result.danger.push({ name: item.gathDtm, y: item.dangerCnt });
        result.off.push({ name: item.gathDtm, y: item.offCnt });
      });
      setChartData(result);
      setLoading(false);
    });
  };

  useEffect(() => {
    initChartDataFunc();
  }, [dongCode]);

  // 차트 옵션
  let chartConfig = {
    chart: {
      type: 'column',
      zoomType: 'xy',
      backgroundColor: '#FFFFFF',
    },
    title: { text: null },
    xAxis: [{ type: 'category', crosshair: true }],
    yAxis: [
      {
        title: {
          text: '(명수)',
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color:
              // theme
              (Highcharts.defaultOptions.title.style && Highcharts.defaultOptions.title.style.color) || 'gray',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      formatter: function () {
        let result = '<small>' + this.points[0].key + '</small>' + '<br/>';
        for (let i = 0; i < this.points.length; i++) {
          result += '<span style="color:' + this.points[i].point.color + '">\u25CF</span> ';
          result += this.points[i].series.name;
          result += ' : ';
          result += numFormat(this.points[i].y) + '<br/>';
        }
        return '<span>' + '<b>' + result + '</b>' + '</span>';
      },
    },
    legend: false,
    plotOptions: {},
    series: [
      {
        name: '경고',
        tooltip: {
          valueSuffix: ' 명',
        },
        labels: {
          format: '{value:,.0f}',
        },
        color: '#f8ac29',
        data: chartData.warn,
      },
      {
        name: '위험',
        tooltip: {
          valueSuffix: ' 명',
        },
        labels: {
          format: '{value:,.0f}',
        },
        color: '#ee2a14',
        data: chartData.danger,
      },
      {
        name: '미작동',
        tooltip: {
          valueSuffix: ' 명',
        },
        labels: {
          format: '{value:,.0f}',
        },
        color: '#989898',
        data: chartData.off,
      },
    ],
  };

  Highcharts.setOptions({
    lang: {
      resetZoom: '초기화',
    },
  });

  return (
    <div
      style={
        loading
          ? {
              opacity: 0.6,
              pointerEvents: 'none',
              position: 'relative',
            }
          : null
      }>
      <HighchartsReact Highcharts={Highcharts} options={chartConfig}></HighchartsReact>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </div>
  );
};

export default WeekEventChart;
